module.exports = __webpack_public_path__ + "img/au.3c39ab22.svg";